module.exports = __webpack_public_path__ + "img/title.ee2782d1.png";